<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`公司利润表_单车订单列表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template #month="params">
        {{ params.params.month ? Number(params.params.month.split('-')[1]) + '月' : "-" }}
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'dwages',
      getListUrl: 'order',
      breadcrumb: [
        { name: '财务管理', path: '/finance/companyProfit' },
        { name: '公司利润表', path: '/finance/companyProfit' },
        // { name: '车队列表' },
      ],
      formInline: {
        month: undefined,
        license: undefined,
      },
      formCtrl: [
        {
          ...this.ctrls.license,
          label: "车牌号：",
        },
        {
          label: "月份：",
          placeholder: "请选择月份",
          keyName: "month",
          type: 'month',
        },
        {
          label: "订单编号：",
          placeholder: "请填写订单编号",
          keyName: "order_num",
          type: 'text',
        },
      ],
      cols: [
        { prop: "order_num", label: "订单编号", width: 150 },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "name", label: "货物名称" },
        { prop: "shname", label: "客户名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: "starttime", label: "装货日期", width: 120 },
      ],
      btns: [
        // {
        //   ...this.viewBtn,
        //   cb: ({ id }) => {
        //     this.$router.push(
        //       `/customer/edit?id=${id}&mode=edit`
        //     );
        //   },
        // },
      ],
      getTotalProperty: ['drivermoney', 'escortmoney', "fleetmoney", "allfreight", "allrepair", "allfixed", "gomoney", "allprofit"],
      baseParams: ['month', 'license'],
    };
  },
  methods: {},
  mounted() {
    // console.log({ ...this.formInline })
    const { month, license } = this.$route.query
    this.MONTH = this.formInline.month = month + ''
    this.formInline.license = license
    // console.log({ ...this.formInline })
    this.getList()
  },
};
</script>
